import * as API from '../api'
import { generate_timestamp } from '../utils/timestamp'
import { openOrDownloadPdf, downloadFile } from '../utils/downloads'

export const FETCHING_CABINETS = 'FETCHING_CABINETS'
export const FETCH_CABINETS = 'FETCH_CABINETS'
export const FETCH_CABINETS_ERROR = 'FETCH_CABINETS_ERROR'

export const ADDING_CABINET = 'ADDING_CABINET'
export const ADD_CABINET = 'ADD_CABINET'
export const ADD_CABINET_ERROR = 'ADD_CABINET_ERROR'

export const UPDATING_CABINET = 'UPDATING_CABINET'
export const UPDATE_CABINET = 'UPDATE_CABINET'
export const UPDATE_CABINET_ERROR = 'UPDATE_CABINET_ERROR'

export const REMOVING_CABINET = 'REMOVING_CABINET'
export const REMOVE_CABINET = 'REMOVE_CABINET'
export const REMOVE_CABINET_ERROR = 'REMOVE_CABINET_ERROR'

export const SEARCHING_CABINET = 'SEARCHING_CABINET'
export const SEARCH_CABINET = 'SEARCH_CABINET'
export const SEARCH_CABINET_ERROR = 'SEARCH_CABINET_ERROR'

export const ADDING_CABINET_PRODUCT = 'ADDING_CABINET_PRODUCT'
export const ADD_CABINET_PRODUCT = 'ADD_CABINET_PRODUCT'
export const ADD_CABINET_PRODUCT_ERROR = 'ADD_CABINET_PRODUCT_ERROR'

export const REMOVING_CABINET_PRODUCT = 'REMOVING_CABINET_PRODUCT'
export const REMOVE_CABINET_PRODUCT = 'REMOVE_CABINET_PRODUCT'
export const REMOVE_CABINET_PRODUCT_ERROR = 'REMOVE_CABINET_PRODUCT_ERROR'

export const CHANGE_SELECT_INPUT = 'CHANGE_SELECT_INPUT'
export const CHANGE_LAST_UPDATE = 'CHANGE_LAST_UPDATE'

export const FETCHING_DOWNLOAD_PDF = 'FETCHING_DOWNLOAD_PDF'
export const FETCH_DOWNLOAD_PDF = 'FETCH_DOWNLOAD_PDF'
export const FETCH_DOWNLOAD_PDF_ERROR = 'FETCH_DOWNLOAD_PDF_ERROR'

export const CHANGE_STATUS_DOWNLOAD_ERROR = 'CHANGE_STATUS_DOWNLOAD_ERROR'

export const FETCHING_QRCODE = 'FETCHING_QRCODE'
export const FETCH_QRCODE = 'FETCH_QRCODE'
export const FETCH_QRCODE_ERROR = 'FETCH_QRCODE_ERROR'

export const addCabinet = ({ areaId = '', name = '' }) => {
  return dispatch => {
    dispatch({
      type: ADDING_CABINET
    })

    return API.incompatibilityAnalysis
      .addCabinet({ areaId, name })
      .then(response => {
        dispatch({
          type: CHANGE_LAST_UPDATE
        })

        dispatch({
          type: ADD_CABINET,
          cabinet: response.data
        })
      })
      .catch(err => {
        dispatch({
          type: ADD_CABINET_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const updateCabinet = ({ areaId, id, name }) => {
  return dispatch => {
    dispatch({
      type: UPDATING_CABINET
    })

    return API.incompatibilityAnalysis
      .updateCabinet({ areaId, id, name })
      .then(response => {
        dispatch({
          type: UPDATE_CABINET,
          cabinet: response.data
        })
      })
      .catch(err => {
        dispatch({
          type: UPDATE_CABINET_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const removeCabinet = ({ areaId, cabinetId }) => {
  return dispatch => {
    dispatch({
      type: REMOVING_CABINET,
      cabinetId
    })

    return API.incompatibilityAnalysis
      .removeCabinet({ areaId, cabinetId })
      .then(() => {
        dispatch({
          type: CHANGE_LAST_UPDATE
        })

        dispatch({
          type: REMOVE_CABINET,
          cabinetId
        })
      })
      .catch(err => {
        dispatch({
          type: REMOVE_CABINET_ERROR,
          cabinetId
        })

        return Promise.reject(err)
      })
  }
}

export const fetchCabinets = ({ areaId }) => {
  return dispatch => {
    dispatch({
      type: FETCHING_CABINETS
    })

    return API.incompatibilityAnalysis
      .getCabinets(areaId)
      .then(response => {
        dispatch({
          type: FETCH_CABINETS,
          cabinets: response.data.cabinets,
          last_update: response.data.last_update
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_CABINETS_ERROR
        })
      })
  }
}

export const searchCabinetProduct = ({ areaId, term, cabinetId }) => {
  const apiDataToOptions = items => {
    return items.map(item => ({ value: item.id, label: item.name, provider: item.provider }))
  }

  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SEARCHING_CABINET
      })

      API.incompatibilityAnalysis
        .searchCabinetProduct({ areaId, term, cabinetId })
        .then(results => {
          dispatch({
            type: SEARCH_CABINET
          })

          const items = ((results || {}).data || {}).items || []
          const options = apiDataToOptions(items)

          resolve(options)
        })
        .catch(err => {
          dispatch({
            type: SEARCH_CABINET_ERROR
          })

          reject(err)
        })
    })
  }
}

export const addCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return dispatch => {
    dispatch({
      type: ADDING_CABINET_PRODUCT,
      cabinetId
    })

    return API.incompatibilityAnalysis
      .addCabinetProduct({ areaId, productId, cabinetId })
      .then(response => {
        dispatch({
          type: CHANGE_LAST_UPDATE
        })

        dispatch({
          type: ADD_CABINET_PRODUCT,
          product: response.data,
          cabinetId
        })
      })
      .catch(err => {
        dispatch({
          type: ADD_CABINET_PRODUCT_ERROR
        })
      })
  }
}

export const removeCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: REMOVING_CABINET_PRODUCT,
        cabinetId
      })

      return API.incompatibilityAnalysis
        .removeCabinetProduct({ areaId, productId, cabinetId })
        .then(() => {
          dispatch({
            type: CHANGE_LAST_UPDATE
          })

          dispatch({
            type: REMOVE_CABINET_PRODUCT,
            productId,
            cabinetId
          })

          resolve()
        })
        .catch(err => {
          dispatch({
            type: REMOVE_CABINET_PRODUCT_ERROR,
            cabinetId
          })

          reject(err)
        })
    })
  }
}

export const cabinetSelectInputChange = (value, cabinetId) => {
  return dispatch => {
    dispatch({
      type: CHANGE_SELECT_INPUT,
      value,
      cabinet: cabinetId
    })
  }
}

export const fetchDownloadPdf = (areaId, cabinetId) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    return API.incompatibilityAnalysis
      .downloadPdf(areaId, cabinetId)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename = 'Estoque de Produtos ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}

export const changeStatusDownloadError = () => {
  return dispatch => {
    dispatch({ type: CHANGE_STATUS_DOWNLOAD_ERROR })
  }
}

export const fetchCabinetQrCode = (id, name) => {
  return dispatch => {
    dispatch({ type: FETCHING_QRCODE })

    return API.incompatibilityAnalysis
      .getQrCode(id)
      .then(response => {
        dispatch({ type: FETCH_QRCODE })
        const { data } = response

        const link = document.createElement('a')

        const filename = `armario-${name}.png`

        const blob = new Blob([data], { type: 'image/png' })

        downloadFile(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_QRCODE_ERROR })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/incompatibilityAnalysis.js